import { useLingui } from '@lingui/react/macro';

import {
  FilterCheckboxItem,
  FilterItemNoResults,
  FiltersList,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import IconPerson from '@/icons/User.svg';

import { useFilters } from '../FiltersState';
import { useApplicantOptions } from '../utils';

export const FiltersApplicant = () => {
  const { t, i18n } = useLingui();

  const {
    requestorTypes: { requestorTypes, setRequestorTypes },
  } = useFilters();

  const applicantOptions = useApplicantOptions();

  const toggleRequestorType = (type: (typeof requestorTypes)[number]) => {
    if (requestorTypes.includes(type)) {
      setRequestorTypes(requestorTypes.filter((t) => t !== type));
    } else {
      setRequestorTypes([...requestorTypes, type]);
    }
  };

  const options =
    applicantOptions.length > 0 ? (
      applicantOptions.map(({ id, label }) => (
        <FilterCheckboxItem key={id} id={id} label={i18n._(label)} />
      ))
    ) : (
      <FilterItemNoResults />
    );

  return (
    <FiltersSubMenu
      id="applicant-type"
      icon={<IconPerson />}
      label={t({ id: 'requests.filters.applicant.label', message: 'Applicant type' })}
      count={requestorTypes.length}
    >
      <FiltersList
        ariaLabel={t({ id: 'requests.filters.applicant.label', message: 'Applicant type' })}
        values={requestorTypes}
        onChange={toggleRequestorType}
      >
        {options}
      </FiltersList>
    </FiltersSubMenu>
  );
};
